import { cityData, matchData } from "../utils/CityData";
import React, { useState, useRef } from "react";
import axios from "axios";
import Select from "react-select";
import { useSnackbar } from "notistack";
import logo from "../assets/images/paypro-logo.png"
import sideImg from "../assets/images/bg.jpg"
import {useGoogleReCaptcha} from "react-google-recaptcha-v3";
import {createRenderer} from "react-dom/test-utils";

function LeadForm() {
    const {executeRecaptcha} = useGoogleReCaptcha();
    const [loading,setLoading] = useState(false)
    const { enqueueSnackbar } = useSnackbar();
    const [selectedCity, setSelectedCity] = useState('');
    const [region, setRegion] = useState('');
    const [firstName, setFirstName] = useState('');
    const [email, setEmail] = useState("");
    const [mobile, setMobile] = useState('');
    const [business, setBusiness] = useState('');
    const [website, setWebsite] = useState('');
    const [constValue] = useState("03")
    const [validationMessages, setValidationMessages] = useState({});

    const selectRef = useRef(null);





    const handleCityChange = (event) => {
        const cityValue = event?.value;
        if (cityValue == null) {
            setSelectedCity(''); // Clear the selected city
            setRegion(''); // Clear the region
        } else {
            setSelectedCity(event.value);
            const cityData = matchData?.find(item => item.city === cityValue);
            setRegion(cityData ? cityData.Region : 'Region not found');
        }
    };

    const handleChangeMobile = (e) => {
        // Get the input value
        let value = e.target.value;

        if (/^\d{0,9}$/.test(value)) {
            setMobile(value);
        }

    };



    const clearValue = () => {
        selectRef.current.clearValue();
    };



    function getFormattedDate() {
        // Get the current date
        const currentDate = new Date();

        // Extract day, month, and year components
        const day = currentDate.getDate();
        const month = currentDate.getMonth() + 1; // Months are zero-based, so add 1
        const year = currentDate.getFullYear();

        // Format the date as "1/8/2024"
        const formattedDate = `${month}/${day}/${year}`;

        return formattedDate;
    }

    const validateForm = () => {
        const messages = {};
        if (!firstName) messages.firstName = "First name is required";
        if (!email) {
            messages.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            messages.email = "Email address is invalid";
        }
        if (!mobile) {
            messages.mobile = "Mobile number is required";
        } else if (!/^\d{9}$/.test(mobile)) {
            messages.mobile = "Mobile number must be 9 digits";
        }
        if (!business) messages.business = "Business name is required";
        if (!website) messages.website = "Website URL is required";
        if (!selectedCity) messages.selectedCity = "City is required";

        setValidationMessages(messages);
        return Object.keys(messages).length === 0;
    };


    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     setLoading(true)
    //     if (!executeRecaptcha) {
    //         setLoading(false);
    //         return;
    //     }
    //     const formattedDate = getFormattedDate();
    //     if (!validateForm()) {
    //         setLoading(false)
    //         return;
    //     }
    //
    //     const formEle = document.querySelector("form");
    //     const formData = new FormData(formEle);
    //     formData.append('Date', formattedDate);
    //     formData.append('Name', firstName);
    //     formData.append('Email', email);
    //     formData.append('PhoneNumber', constValue+mobile);
    //     formData.append('Business', business);
    //     formData.append('Website', website);
    //     formData.append('City', selectedCity);
    //     formData.append('Source', "Google");
    //
    //
    //     const token = await executeRecaptcha("submit_form");
    //
    //
    //     try {
    //         // Send the token to the backend for verification using axios
    //         const response = await axios.post("https://qrbackend.paypro.com.pk/api/paypro/verify-captcha", {
    //             token // Sending the token only
    //         });
    //         const data = response.data;
    //
    //         // Handle the response from the backend
    //         if (data.success) {
    //
    //             const apiUrl1 = region === "South"
    //                 ? "https://script.google.com/macros/s/AKfycbwPmqERmWHrkVcfXLutmBpo04CN7BVuqfKuHUTLXe2X6yqj9LIJPiOBUeyKGvcSvnzvng/exec"
    //                 : "https://script.google.com/macros/s/AKfycbyNyd04L12mSLaqDdLqPpH79VUHHDJQnF3y50W9HiQnSCIOoMw6UOsg0S6_iNsjG5rcYg/exec";
    //             const apiUrl2 = 'https://democrmapi.paypro.com.pk/api/lead/App_lead'
    //             try {
    //                 // Make two parallel requests
    //                 const [response1] = await Promise.all([
    //                     axios.post(apiUrl1, formData),
    //                     // axios.post(apiUrl2, {
    //                     //     first_name:firstName,
    //                     //     last_name:"null",
    //                     //     email:email,
    //                     //     mobile:constValue+mobile,
    //                     //     company:business,
    //                     //     website:website,
    //                     //     city:selectedCity,
    //                     //     region:region,
    //                     //     lead_menu_code:'D960E043-F097-470B-99E2-EE0A9B9BB640'
    //                     // })
    //                 ]);
    //
    //                 // Assuming both APIs succeed, you can handle their responses here
    //                 console.log("Response from API 1:", response1.data);
    //                 // console.log("Response from API 2:", response2.data);
    //
    //                 enqueueSnackbar("Form Sent Successfully", { variant: "success" });
    //                 setLoading(false);
    //                 setFirstName('');
    //                 setEmail('');
    //                 setMobile('');
    //                 setBusiness('');
    //                 setWebsite('');
    //                 setSelectedCity('');
    //                 setRegion('');
    //                 clearValue();
    //             } catch (error) {
    //                 // Handle errors for both APIs
    //                 enqueueSnackbar("Error occurred while sending form", { variant: "error" });
    //                 console.error("Error:", error);
    //                 setLoading(false);
    //             }
    //         }
    //     } catch (error) {
    //         console.error("Error verifying captcha", error);
    //         setLoading(false);
    //     }
    //
    //
    // };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        // Get the formatted date and validate the form
        const formattedDate = getFormattedDate();
        if (!validateForm()) {
            setLoading(false);
            return;
        }

        // Prepare the form data
        const formEle = document.querySelector("form");
        const formData = new FormData(formEle);
        formData.append('Date', formattedDate);
        formData.append('Name', firstName);
        formData.append('Email', email);
        formData.append('PhoneNumber', constValue + mobile);
        formData.append('Business', business);
        formData.append('Website', website);
        formData.append('City', selectedCity);
        formData.append('Source', "Google");

        // Prepare API URLs
        const apiUrl1 = region === "South"
            ? "https://script.google.com/macros/s/AKfycbwPmqERmWHrkVcfXLutmBpo04CN7BVuqfKuHUTLXe2X6yqj9LIJPiOBUeyKGvcSvnzvng/exec"
            : "https://script.google.com/macros/s/AKfycbyNyd04L12mSLaqDdLqPpH79VUHHDJQnF3y50W9HiQnSCIOoMw6UOsg0S6_iNsjG5rcYg/exec";

        const apiUrl2 = 'https://democrmapi.paypro.com.pk/api/lead/App_lead';

        try {
            // Make parallel requests
            const [response1] = await Promise.all([
                axios.post(apiUrl1, formData),
                // Uncomment and configure the second API call if needed
                // axios.post(apiUrl2, {
                //     first_name: firstName,
                //     last_name: "null",
                //     email: email,
                //     mobile: constValue + mobile,
                //     company: business,
                //     website: website,
                //     city: selectedCity,
                //     region: region,
                //     lead_menu_code: 'D960E043-F097-470B-99E2-EE0A9B9BB640'
                // })
            ]);

            // Assuming both APIs succeed, handle the responses here
            console.log("Response from API 1:", response1.data);

            // Show success notification
            enqueueSnackbar("Form Sent Successfully", { variant: "success" });

            // Reset form and loading state
            setLoading(false);
            setFirstName('');
            setEmail('');
            setMobile('');
            setBusiness('');
            setWebsite('');
            setSelectedCity('');
            setRegion('');
            clearValue();

        } catch (error) {
            // Handle errors for both APIs
            enqueueSnackbar("Error occurred while sending form", { variant: "error" });
            console.error("Error:", error);
            setLoading(false);
        }
    };

    return (
        <div className="min-w-screen min-h-screen bg-white flex items-center justify-center px-5 py-5">

        <div className=" flex flex-col  md:flex-row items-center justify-center gap-10 w-full xl:w-8/12 2xl:w-7/12">

            <div className='hidden lg:block lg:w-3/6 flex items-center justify-center'>
                <img className="w-full " src={sideImg} alt={sideImg}/>
            </div>

            <div className=' w-full md:w-8/12  lg:w-3/6 border-2 px-4 py-8 shadow-xl rounded-3xl'>
                <div>
                   <div className='w-full flex items-center justify-between'>
                       <h2 className="text-2xl md:text-4xl pb-2">Personal Details</h2>
                       <img className="w-8 lg:w-10" src={logo} alt={logo} />
                   </div>

                   <form onSubmit={(e) => handleSubmit(e)} className="w-full flex flex-col gap-2">
                       <div className='w-full flex flex-col '>
                           <div className="flex">
                               <label className="block font-medium text-sm text-gray-700">
                                   <span>Name</span></label><
                               span className="text-red-600"> *</span>
                           </div>
                           <input value={firstName} onChange={(e) => setFirstName(e.target.value)} className="border-gray-300 p-2 border-2 focus:border-blue-400 focus:ring focus:ring-blue-200 focus:ring-opacity-50 rounded-md shadow-sm  block w-full" />
                           {validationMessages.firstName && <p className="text-red-500 text-sm">{validationMessages.firstName}</p>}
                       </div>
                       <div className='w-full flex flex-col '>
                           <div className="flex">
                               <label className="block font-medium text-sm text-gray-700">
                                   <span>Email</span></label><
                               span className="text-red-600"> *</span>
                           </div>
                           <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" className="border-gray-300 p-2 border-2 focus:border-blue-400 focus:ring focus:ring-blue-200 focus:ring-opacity-50 rounded-md shadow-sm  block w-full" />
                           {validationMessages.email && <p className="text-red-500 text-sm">{validationMessages.email}</p>}

                       </div>
                       <div className='w-full flex flex-col '>
                           <div className="flex">
                               <label className="block font-medium text-sm text-gray-700">
                                   <span>Mobile No</span></label><
                               span className="text-red-600"> *</span>
                           </div>
                           <div className="flex items-center gap-1">
                               <input  placeholder="03"   value={constValue}  disabled  type="text" className="border-gray-300 p-2 border-2 focus:border-blue-400 focus:ring focus:ring-blue-200 focus:ring-opacity-50 rounded-md shadow-sm  block w-10" />
                               <input value={mobile} placeholder="XXXXXXXXX"  maxLength="9"   onChange={handleChangeMobile}   type="text" className="border-gray-300 p-2 border-2 focus:border-blue-400 focus:ring focus:ring-blue-200 focus:ring-opacity-50 rounded-md shadow-sm  block w-full" />

                           </div>
                           {validationMessages.mobile && <p className="text-red-500 text-sm">{validationMessages.mobile}</p>}
                       </div>
                       <div className='w-full flex flex-col '>
                           <div className="flex">
                               <label className="block font-medium text-sm text-gray-700">
                                   <span>Business Name</span></label><
                               span className="text-red-600"> *</span>
                           </div>
                           <input value={business} onChange={(e) => setBusiness(e.target.value)} className="border-gray-300 p-2 border-2 focus:border-blue-400 focus:ring focus:ring-blue-200 focus:ring-opacity-50 rounded-md shadow-sm  block w-full" />
                           {validationMessages.business && <p className="text-red-500 text-sm">{validationMessages.business}</p>}
                       </div>
                       <div className='w-full flex flex-col '>
                           <div className="flex">
                               <label className="block font-medium text-sm text-gray-700">
                                   <span>Website</span></label><
                               span className="text-red-600"> *</span>
                           </div>
                           <input value={website} onChange={(e) => setWebsite(e.target.value)} type="text" className="border-gray-300 p-2 border-2 focus:border-blue-400 focus:ring focus:ring-blue-200 focus:ring-opacity-50 rounded-md shadow-sm  block w-full" />
                           {validationMessages.website && <p className="text-red-500 text-sm">{validationMessages.website}</p>}
                       </div>
                       <div className='w-full flex flex-col '>
                           <div className="flex">
                               <label className="block font-medium text-sm text-gray-700">
                                   <span>City</span></label><
                               span className="text-red-600"> *</span>
                           </div>
                           <Select
                               ref={selectRef}
                               value={cityData.find(city => city.value === selectedCity)}
                               onChange={handleCityChange}
                               options={cityData}
                               isClearable={true}
                               isSearchable={true}
                               placeholder="Select City"
                               className="react-select-container"
                               classNamePrefix="react-select"
                           />
                           {validationMessages.selectedCity && <p className="text-red-500 text-sm">{validationMessages.selectedCity}</p>}
                       </div>

                       <div className="flex flex-col mt-8 mb-2 lg:mb-5">
                           <div className="w-full px-3">
                               {loading ? (
                                   <button type="button" className="block w-full max-w-xs mx-auto bg-[#91B3FA] hover:bg-[#120878] text-white rounded-lg px-3 py-3 font-semibold" disabled>
                                       <svg aria-hidden="true" role="status" className="inline mr-3 w-4 h-4 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                           <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB"></path>
                                           <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"></path>
                                       </svg>
                                       Processing...
                                   </button>
                               ) : (
                                   <button type="submit" className="block w-full max-w-xs mx-auto bg-[#91B3FA] hover:bg-[#120878] text-white rounded-lg px-3 py-3 font-semibold">Submit</button>

                               )}
                           </div>
                       </div>
                   </form>
                </div>
            </div>
        </div>


        </div>
    );
}

export default LeadForm;
